/* eslint-disable no-nested-ternary */
import React from 'react';
import PropTypes from 'prop-types';

export default function Input({
  id,
  name,
  label,
  type,
  disabled,
  hasError,
  hasWarn,
  errorText,
  warnText,

  ...props
}) {
  let hasAlertClassName = hasError
    ? 'sdp-fieldset--error'
    : hasWarn
    ? 'sdp-fieldset--warning'
    : '';
  return (
    <div className={`sdp-fieldset ${hasAlertClassName}`}>
      <label className="sdp-form-label" htmlFor={id}>
        {label}
      </label>
      {type === 'text-area' ? (
        <textarea
          className="sdp-form-input"
          id={id}
          name={name}
          disabled={disabled}
          {...props}
        />
      ) : (
        <input
          className="sdp-form-input"
          id={id}
          name={name}
          disabled={disabled}
          type={type}
          {...props}
        />
      )}
      {hasWarn && (
        <label className="sdp-form-feedback" htmlFor={id}>
          {warnText}
        </label>
      )}
      {hasError && (
        <label className="sdp-form-feedback" htmlFor={id}>
          {errorText}
        </label>
      )}
    </div>
  );
}

Input.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.oneOf(['text', 'text-area', 'email', 'password', 'number']),
  disabled: PropTypes.bool,
  hasError: PropTypes.bool,
  hasWarn: PropTypes.bool,
  errorText: PropTypes.string,
  warnText: PropTypes.string
};

Input.defaultProps = {
  id: 'myInput',
  name: 'myInput',
  label: 'My Input Label',
  type: 'text',
  disabled: false,
  hasError: false,
  hasWarn: false,
  errorText: '',
  warnText: ''
};
